import { Event, EventPublisher } from 'pubsub/eventsV2'
import { TealiumEvent } from '.'

export type TealiumActivity = {
  sessionId?: string
} & TealiumEvent

const subscribe = (eventPublisher: EventPublisher) => {
  return eventPublisher.subscribe({
    next: (event: Event) => {
      if (!event.tealium) {
        return
      }
      const { additionalData, ...data } = event.tealium
      // call via the exported const so that we can appropriately spyOn this call in jest for testing
      tealiumEventSubscriber.sendTealiumEvent({
        sessionId: event.sessionId,
        ...data,
        ...additionalData
      })
    }
  })
}

const sendTealiumEvent = async (event: TealiumActivity) => {
  window.utag?.link(event)
}

export const tealiumEventSubscriber = {
  subscribe,
  sendTealiumEvent
}
